import React, { useCallback } from 'react';
import { useFormState } from 'react-final-form';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import ThumbUp from '@material-ui/icons/ThumbUp';
import { useTranslate, useUpdate, useNotify, useRedirect } from 'react-admin';

/**
 * This custom button demonstrate using useUpdate to update data
 */
const AcceptButton = ({ record, action = 'accept' }) => {
    const translate = useTranslate();
    const notify = useNotify();
    const redirectTo = useRedirect();
    // const [update] = useUpdate('issues');
    const formState = useFormState();

    const [approve, { loading }] = useUpdate(
      'issues',
      record.id,
      {
          comment: formState.values.comment,
          status: action === 'close' ? 'resolved' : 'in_progress',
          issue_manager: formState.values.issue_manager
      },
      record,
      {
          undoable: true,
          onSuccess: () => {
              notify(
                  'resources.issues.notification.approved_success',
                  'info',
                  {},
                  true
              );
              redirectTo('/issues');
          },
          onFailure: () => {
              notify(
                  'resources.issues.notification.approved_error',
                  'warning'
              );
          },
      }
    );

    const handleClick = useCallback(() => {
        if (!formState.valid) {
            return;
        }
        approve();
    }, [
        formState.valid,
        approve,
    ]);


    return record && (
                record.status === 'new' || record.status === 'in_progress'
        ) ? (
        <Button
            variant="contained"
            color="primary"
            onClick={handleClick}
            disabled={loading}
        >
            <ThumbUp
                style={{ paddingRight: '0.5em', color: 'white' }}
            />
            {
                translate('resources.issues.action.accept')
            }

        </Button>
    ) : (
        <span />
    );
};

AcceptButton.propTypes = {
    record: PropTypes.object,
};

export default AcceptButton;
